/** Tiny toast queue with optional undo, rendered by <Toaster/>. */
import { create } from "zustand";

export type Toast = { id: number; message: string; tone?: "info" | "error"; action?: { label: string; run: () => void } };

type State = { toasts: Toast[]; push: (t: Omit<Toast, "id">) => void; dismiss: (id: number) => void };

let seq = 0;
export const useToasts = create<State>((set, get) => ({
  toasts: [],
  push(t) {
    const id = ++seq;
    set((s) => ({ toasts: [...s.toasts, { ...t, id }] }));
    setTimeout(() => get().dismiss(id), t.action ? 6000 : 3500);
  },
  dismiss(id) {
    set((s) => ({ toasts: s.toasts.filter((x) => x.id !== id) }));
  },
}));

export const toast = (message: string, opts?: Omit<Toast, "id" | "message">) => useToasts.getState().push({ message, ...opts });
